import GenericTabComponent from "../../components/GenericTabComponent";
import About from "./Tabs/About";
import AdjacentPlacesOfAttraction from "./Tabs/AdjacentPlacesOfAttraction";
import ContactDetails from "./Tabs/ContactDetails";
import HowToReachRajgir from "./Tabs/HowToReachRajgir";
import LogoMascot from "./Tabs/LogoMascot";
import MatchFixtures from "./Tabs/MatchFixtures";
import TicketLink from "./Tabs/TicketLink";
import TournamnetSouvenirs from "./Tabs/TournamnetSouvenirs";
import TrophyTour from "./Tabs/TrophyTour";

export default function HeroAsiaCup2025() {
  const content = [
    { label: "विषय", component: <About /> },
    { label: "शुभंकर", component: <LogoMascot /> },
    // { label: "Trophy Tour", component: <TrophyTour /> },
    { label: "खेल सारणी", component: <MatchFixtures /> },
    { label: "राजगीर कैसे पहुँचें", component: <HowToReachRajgir /> },
    {
      label: "निकटवर्ती आकर्षण स्थल",
      component: <AdjacentPlacesOfAttraction />,
    },
    // { label: "Souvenir", component: <TournamnetSouvenirs /> },
    // { label: "Book Your Pass", component: <TicketLink /> },
    // { label: "Contact Us", component: <ContactDetails /> },
  ];
  const pagetitle = "पुरुष एशिया हॉकी कप 2025",
    // desktopBanner = "/img/HeroMensHockeyAsiaCup2025Rajgir/desktopBanner.jpg",
    desktopBanner = "/img/model-code-conduct/HeroMensHockeyAsiaCup2025Rajgir/desktopBanner.jpg",
    // mobileBanner = "/img/HeroMensHockeyAsiaCup2025Rajgir/mobileBanner.jpg";
    mobileBanner = "/img/model-code-conduct/HeroMensHockeyAsiaCup2025Rajgir/mobileBanner.jpg";
  return (
    <>
      <GenericTabComponent
        content={content}
        desktopBanner={desktopBanner}
        mobileBanner={mobileBanner}
        pageTitle={pagetitle}
      />
    </>
  );
}
